import { client } from "./client.ts";

const BASE_URL = "/server-rule";

export const getAIServerList = async () => {
  try {
    const response = await client.get(`${BASE_URL}/get-server-list`);
    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAIServerDetail = async (id) => {
  try {
    const response = await client.get(`${BASE_URL}/get-server-detail/${id}`);
    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateAIServer = async (data) => {
  try {
    const response = await client.put(`${BASE_URL}/update-server`, data);
    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteAIServer = async (id) => {
  try {
    const response = await client.delete(`${BASE_URL}/delete-server/${id}`);
    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createAIServer = async (data) => {
  try {
    const response = await client.post(`${BASE_URL}/create-server`, data);
    // console.log(response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
